export default __webpack_public_path__ + "static/media/or_david.29f9fbec.png";